import type { SVGProps } from 'react';

export const SvgImgIllustFurusato = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 202 171" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M102.001 159.094L2 101.359L101.999 43.6246L202 101.36L102.001 159.094Z"
      fill="#FBDED7"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M2 111.444V101.359L102.001 159.094V169.18L2 111.444Z"
      fill="url(#paint0_linear_4444_1898)"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M201.999 101.36V111.444L102 169.18V159.094L201.999 101.36Z"
      fill="url(#paint1_linear_4444_1898)"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M94.2292 75.5126L141.629 48.1435L107.395 28.3776L59.9946 55.7467L94.2292 75.5126Z"
      fill="#DEBD8D"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M78.6157 66.4993L126.016 39.1302L123.003 37.391L75.6025 64.7601L78.6157 66.4993Z"
      fill="#FF0019"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M94.228 101.36L141.63 73.9937L141.628 48.1478L94.2266 75.5126L94.228 101.36Z"
      fill="#C79B69"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M59.9902 81.5955L94.2248 101.36L94.2262 75.5126L59.9902 55.7482V81.5955Z"
      fill="#DEBD8D"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M78.6142 72.9401L78.6157 66.5008L75.6025 64.7616V71.201L78.6142 72.9401Z"
      fill="#FF0019"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M78.6157 92.3466V85.9073L75.6025 84.1681V90.6074L78.6157 92.3466Z"
      fill="#FF0019"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M95.9569 43.9884L128.575 25.1544L105.664 11.9249L73.0459 30.7589L95.9569 43.9884Z"
      fill="#DEBD8D"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M86.0073 38.2434L118.626 19.4094L115.613 17.6702L82.9941 36.5042L86.0073 38.2434Z"
      fill="#FF0019"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M95.9585 61.5498L128.577 42.7158V25.1543L95.9585 43.9883V61.5498Z"
      fill="#C79B69"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M73.0459 48.3219L95.9583 61.5499L95.9598 43.9884L73.0473 30.7604L73.0459 48.3219Z"
      fill="#DEBD8D"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M86.0073 44.1245V38.2445L82.9941 36.5039V42.3853L86.0073 44.1245Z"
      fill="#FF0019"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M86.0073 55.8048V49.9248L82.9941 48.1842V54.0656L86.0073 55.8048Z"
      fill="#FF0019"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M99.7873 23.5122L119.331 12.2278L101.835 2.12598L82.291 13.4104L99.7873 23.5122Z"
      fill="#DEBD8D"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M92.4116 19.2525L111.956 7.96804L109.214 6.38538L89.6694 17.6698L92.4116 19.2525Z"
      fill="#FF0019"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M82.291 25.2426L99.7873 35.3444L99.7887 23.5121L82.2925 13.4117L82.291 25.2426Z"
      fill="#DEBD8D"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M92.4072 22.6499L92.4086 19.2542L89.6665 17.6715L89.665 21.0673L92.4072 22.6499Z"
      fill="#FF0019"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M92.4072 31.085V27.8341L89.665 26.2515V29.5023L92.4072 31.085Z"
      fill="#FF0019"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M99.7866 35.3447L119.332 24.0617L119.331 12.2294L99.7866 23.5124V35.3447Z"
      fill="#C79B69"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <defs>
      <linearGradient
        id="paint0_linear_4444_1898"
        x1="54.0308"
        y1="131.809"
        x2="48.1524"
        y2="141.827"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#F29E8A"></stop>
        <stop offset="0.29" stopColor="#F5B3A4"></stop>
        <stop offset="0.75" stopColor="#F9D2C8"></stop>
        <stop offset="1" stopColor="#FBDED7"></stop>
      </linearGradient>
      <linearGradient
        id="paint1_linear_4444_1898"
        x1="152.289"
        y1="176.403"
        x2="151.786"
        y2="104.834"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#F29E8A"></stop>
        <stop offset="0.51" stopColor="#ED8B7D"></stop>
        <stop offset="1" stopColor="#EB7D74"></stop>
      </linearGradient>
    </defs>
  </svg>
);
